import e from "@dialpad/dialtone-tokens/layered/themes/tokens-111-colors.css?inline";
//#region themes/111.js
var t = { brand: {
	css: e,
	name: "111"
} };
//#endregion
export { t as default };
